import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { ViewWillEnter } from '@ionic/angular';
import { RoutesConfigService } from 'src/app/config/routes-config.service';
import { DataService } from 'src/app/services/data.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-desktopnav',
    templateUrl: './desktopnav.component.html',
    styleUrls: ['./desktopnav.component.scss'],
    standalone: false
})
export class DesktopnavComponent implements OnInit {
  private routesConfig = inject(RoutesConfigService);
  public _show:boolean = false;
  public unreadMessagesCount:number = 0;

  get show(){
    // console.log('DesktopnavComponent show '+this.router.url);
    if(
      this.router.url == '/welcomequestionnaire' 
      ||
      this.router.url == '/welcomequestions' 
      || 
      this.router.url == '/fakesplash' 
      || 
      this.router.url == '/login' 
      || 
      this.router.url == '/agreement/age-agreement' 
      || 
      this.router.url == '/register' 
      || 
      this.router.url == '/splash' 
      || 
      this.router.url == '/accesscodes'  
      || 
      this.router.url == '/recoverytimeline'    
      || 
      this.router.url == '/introslider'  
      || 
      this.router.url == '/ppolicy'  
      || 
      this.router.url == '/termsandconditions'  
      || 
      this.router.url == '/guest'  
      || 
      this.router.url.startsWith('/guest?')
      || 
      this.router.url == '/postcode-entry'
      || 
      this.router.url.indexOf('/select-practice') != -1
      || 
      this.router.url == '/select-area'
      || 
      this.router.url == '/create-account'
      || 
      this.router.url.match(/\/gateway\/\d+/) != null
      || 
      this.router.url == '/need-help'
      || 
      this.router.url == '/need-help-thankyou'
      || 
      this.router.url == '/feedbackinput'
      ||
      this.router.url == '/local-service-options'
      ||
      this.router.url == '/select-super-organisation'
      ||
      this.router.url == '/welcome'
      ||
      this.router.url == '/nhs-callback'
      ||
      this.router.url.indexOf('/enter-code/') != -1
      ||
      this.router.url.indexOf('/verify/') != -1
      ||
      this.router.url.match(/\/guest(\?.*)?/)
      ||
      this.routesConfig.underGuestRoute(this.router.url)
      )
      this._show = false
    else
      this._show = true

    return this._show;
  }

  get hasUnreadMessages(): boolean {
    return this.unreadMessagesCount > 0;
  }

  constructor(
    public router: Router,
    public data: DataService,
    public userService: UserService
    ) { 

      this.router.events.subscribe((event) => {
        if(event instanceof NavigationEnd){
          if(
            this.router.url == '/welcomequestionnaire' 
            ||
            this.router.url == '/welcomequestions' 
            || 
            this.router.url == '/fakesplash' 
            || 
            this.router.url == '/login' 
            || 
            this.router.url == '/register' 
            || 
            this.router.url == '/splash' 
            || 
            this.router.url == '/accesscodes'  
            || 
            this.router.url == '/recoverytimeline'    
            || 
            this.router.url == '/introslider'  
            || 
            this.router.url == '/ppolicy'  
            || 
            this.router.url == '/termsandconditions'  
            || 
            this.router.url == '/guest'  
            || 
            this.router.url == '/postcode-entry'
            || 
            this.router.url.indexOf('/select-practice') != -1
            || 
            this.router.url == '/select-area'
            || 
            this.router.url == '/create-account'
            || 
            this.router.url == '/need-help'
            || 
            this.router.url == '/need-help-thankyou'
            || 
            this.router.url == '/feedbackinput'
            ||
            this.router.url == '/local-service-options'
            ||
            this.router.url == '/select-super-organisation'
            ||
            this.router.url == '/welcome'
            ||
            this.router.url == '/nhs-callback'
            ||
            this.router.url.indexOf('/enter-code/') != -1
            ||
            this.router.url.indexOf('/verify/') != -1
            )
            this._show = false
          else
            this._show = true
        }
    });

  }

  private normalizeMenuLabel(value: string): string {
    if (!value) {
      return '';
    }

    const container = document.createElement('div');
    container.innerHTML = value;

    return container.textContent?.trim() || value;
  }

  label(name):string{
    if(this.data.menu){
      let found = this.data.menu.find((e) => e.name == name)
      if(found && found.custom)
        return this.normalizeMenuLabel(found.custom)
    }

    return name
  }
  
  logout(){
    this.data.logout(true, true);
  }

  openUrl(url: string) {
    Browser.open({ 
      url: url, 
      // target="_blank" rel="noopener noreferrer" 
      windowName: '_blank',
     });
  }

  ngOnInit() {
    console.log('DesktopnavComponent ionViewWillEnter');
    this.unreadMessagesCount = this.data.letters.filter((e) => !e.read)?.length || 0;

    // subscribe to view updates
    this.userService.letters$.subscribe((letters) => {
      this.unreadMessagesCount = letters.filter((e) => !e.read)?.length || 0;
    });
  
  }

}
